/**
 * Account Screen
 */
import { graphql } from 'react-apollo'
import gql from 'graphql-tag'

export const addTeamStoreItemMutation = graphql(
  gql`
    mutation AddTeamStoreItem(
      $teamStoreItem: TeamStoreItem!
      $teamStoreId: String!
    ) {
      addTeamStoreItem(
        teamStoreItem: $teamStoreItem
        teamStoreId: $teamStoreId
      ) {
        message
      }
    }
  `,
  { name: 'addItemToStore' }
)

export const profileSettingsQuery = gql`
  query profile {
    profileData: getUserProfile {
      userProfile {
        userId: id
        firstName: first_name
        lastName: last_name
        email
        affiliateEnabled: affiliate_enabled
        country_code
        resellerEnabled: reseller_enabled
        phone
        managerName: account_manager_name
        managerLine: manager_line
        managerEmail: manager_email
      }
      reseller {
        status
        comission
        inline
        displayDynamicBatch: display_dynamic_batch
        displayFixedBatch: display_fixed_batch
      }
      affiliate {
        status
        comission
        activatedAt: activated_at
        file
        currency
        region
        paypalAccount: paypal_account
      }
    }
  }
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/screens/Account/data.ts